import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from '../../components/not-found/not-found.component';
import {BookingV2Component} from './components/booking-v2/booking-v2.component';
import {BookingParamsEnum} from './enums/booking-enums';
import {BookingUnavailableComponent} from './components/booking-unavailable/booking-unavailable.component';

const hideAllData = {layout: {hideAll: true}};
const routes: Routes = [
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}/:${BookingParamsEnum.SERVICE_ID}/:${BookingParamsEnum.TIMESLOT}/${BookingParamsEnum.UNAVAILABLE}`,
    component: BookingUnavailableComponent,
    data: hideAllData,
  },
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}/:${BookingParamsEnum.SERVICE_ID}/${BookingParamsEnum.UNAVAILABLE}`,
    component: BookingUnavailableComponent,
    data: hideAllData,
  },
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}/${BookingParamsEnum.UNAVAILABLE}`,
    component: BookingUnavailableComponent,
    data: hideAllData,
  },
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}/:${BookingParamsEnum.SERVICE_ID}/:${BookingParamsEnum.TIMESLOT}`,
    component: BookingV2Component,
    data: hideAllData,
  },
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}/:${BookingParamsEnum.SERVICE_ID}`,
    component: BookingV2Component,
    data: hideAllData,
  },
  {
    path: `:${BookingParamsEnum.CAREPROVIDER_ID}`,
    component: BookingV2Component,
    data: hideAllData,
  },
  {path: '**', component: NotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingV2RoutingModule {}

export const bookingV2RoutingComponents = [BookingV2Component, BookingUnavailableComponent];
